// extracted by mini-css-extract-plugin
export default {"chatbot1":"app_chatbot1__FyAgA","show":"app_show__FNh0b"};